<template>
    <div data-testid="gl-select-actions" class="gl-select-actions-sticky d-flex gap-4 flex-column flex-wrap">
        <div data-testid="gl-select-actions__toolbar" class="d-flex align-center gap-4 flex-wrap">
            <CountSection :count="data.length" class="gap-120"
                :networkLabel="$nova.labelsName('gl_selection', 'division_label', 'Network')"
                :countLabel="$nova.labelsName('gl_selection', 'commentary_count_label', 'Count')" />
            <v-spacer />

            <CountSection :count="slCount" class="gap-8 flex-row-reverse"
                networkLabel="Drill-Down"
                countLabel="Selected" />
            <CountSection :count="glCount" class="gap-8 flex-row-reverse"
                networkLabel="GL(s)"
                countLabel="Selected" />
            <v-btn data-testid="gl-select-actions__save-button" color="primary" @click="$emit('save')" class='savebtn'
                :disabled="!hasChanges || saving"
                :loading="saving">
                <span>Save</span></v-btn>
        </div>
    </div>
</template>

<script>
import CountSection from './CountSection.vue';
export default {
    name: 'GlSelectActions',
    props: {
        slCount: {
            type: Number,
            default: 0
        },
        glCount: {
            type: Number,
            default: 0
        },
        selectedgls: {
            type: Array,
            default: () => []
        },
        selectedsls: {
            type: Array,
            default: () => []
        },
        savedGlsStatus: {
            type: Array,
            default: () => []
        },
        savedSlsStatus: {
            type: Array,
            default: () => []
        },
        data: {
            type: Array,
            required: true
        },
        /** When true, shows loading spinner on save button */
        saving: {
            type: Boolean,
            default: false
        },
    },
    components: {
        CountSection
    },
    computed: {
        hasChanges() {
            const glsChanged = !(
                this.selectedgls.length === this.savedGlsStatus.length &&
                this.selectedgls.every(c => this.savedGlsStatus.includes(c))
            );
            const slsChanged = !(
                this.selectedsls.length === this.savedSlsStatus.length &&
                this.selectedsls.every(c => this.savedSlsStatus.includes(c))
            );
            return glsChanged || slsChanged;
        }
    }
}
</script>

<style scoped>
.gl-select-actions-sticky {
    position: sticky;
    top: 0;
    z-index: var(--z-nav, 3);
    background: var(--color-surface-default, white);
    padding: var(--space-3, 12px) 0;
}
.savebtn :deep(.v-btn__content) {
    gap: 8px;
}
.v-card > *:first-child:not(.v-btn):not(.v-chip):not(.v-avatar), .v-card > .v-card__progress + *:not(.v-btn):not(.v-chip):not(.v-avatar) {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}
</style>